export default {
  name: 'marking--orderP',
  apiService: 'shoes',
  apiPath: '/admin/order_p',
  enums: {
    certType: ['CONFORMITY_CERTIFICATE', 'CONFORMITY_DECLARATION'],
  }
};